import { COUNTRY_CODES } from "../../../constants/countries";
import { configuracionDePais } from "../../../utils/configuracionDePais";

export const DENOMINACIONES_CONFIG = {
  [COUNTRY_CODES.ECUADOR]: {
    currencySymbol: "$",
    bills: [100, 50, 20, 10, 5, 2, 1],
    coins: [0.5, 0.25, 0.1, 0.05, 0.01],
    useDefaultValues: true,
    defaultValues: {
      50: 1,
      20: 2,
      5: 1,
      1: 4,
      0.5: 1,
    },
    expectedDefaultTotal: 99.5,
  },
  [COUNTRY_CODES.PARAGUAY]: {
    currencySymbol: "₲",
    bills: [100000, 50000, 20000, 10000, 5000, 2000],
    coins: [1000, 500, 100, 50],
    useDefaultValues: false,
  },
  [COUNTRY_CODES.PERU]: {
    currencySymbol: "S/",
    bills: [200, 100, 50, 20, 10],
    coins: [5, 2, 1, 0.5, 0.2, 0.1],
    useDefaultValues: false,
  },
  [COUNTRY_CODES.HONDURAS]: {
    currencySymbol: "L",
    bills: [500, 200, 100, 50, 20, 10, 5, 2],
    coins: [1, 0.5, 0.2, 0.1, 0.05],
    useDefaultValues: false,
  },
  [COUNTRY_CODES.BOLIVIA]: {
    currencySymbol: "Bs",
    bills: [200, 100, 50, 20, 10],
    coins: [5, 2, 1, 0.5, 0.2, 0.1],
    useDefaultValues: false,
  },
  [COUNTRY_CODES.GUATEMALA]: {
    currencySymbol: "Q",
    bills: [200, 100, 50, 20, 10, 5, 1],
    coins: [1, 0.5, 0.25, 0.1, 0.05],
    useDefaultValues: false,
  },
  [COUNTRY_CODES.ELSALVADOR]: {
    currencySymbol: "$",
    bills: [100, 50, 20, 10, 5, 2, 1],
    coins: [0.5, 0.25, 0.1, 0.05, 0.01],
    useDefaultValues: false,
  },
  // Panamá cuenta lo mismo que Ecuador: los dos manejan dólares, así que el
  // cajón trae los mismos billetes --incluido el de 2, que existe y aparece-- y
  // las mismas monedas.
  //
  // Sin fondo de apertura por defecto: los 99,50 de Ecuador son su convención de
  // caja, no algo que se herede por compartir moneda. Se pone el día que
  // Panamá decida el suyo.
  [COUNTRY_CODES.PANAMA]: {
    currencySymbol: "$",
    bills: [100, 50, 20, 10, 5, 2, 1],
    coins: [0.5, 0.25, 0.1, 0.05, 0.01],
    useDefaultValues: false,
  },
  [COUNTRY_CODES.COSTARICA]: {
    currencySymbol: "₡",
    // Los billetes en circulación. El de 50.000 se conserva porque es el que
    // arma el fondo fijo de apertura; los de 1.000 a 20.000 son los que pidió
    // la operación.
    bills: [50000, 20000, 10000, 5000, 2000, 1000],
    // Sin la moneda de 5: no se usa en caja.
    coins: [500, 100, 50, 25, 10],
    useDefaultValues: true,
    // Fondo fijo de apertura: 100.000 colones.
    defaultValues: {
      50000: 1,
      20000: 2,
      10000: 1,
    },
    expectedDefaultTotal: 100000,
  },
};

/**
 * Con cuántos decimales se escribe una denominación.
 *
 * No es el formato de moneda del país: es el de la pieza. Un billete de 500
 * colones se escribe «500», no «500,00000» --Costa Rica declara cinco decimales
 * en el catálogo de países, que es la precisión con la que calcula, no con la
 * que se nombra un billete--. Y una moneda de 0,25 sigue necesitando sus dos.
 *
 * @param {number} valor Denominación.
 * @returns {number} Decimales que hacen falta para escribirla sin sobras.
 */
export const decimalesDeLaDenominacion = (valor) => {
  const texto = String(valor ?? "");
  const punto = texto.indexOf(".");

  return punto < 0 ? 0 : texto.length - punto - 1;
};

/** Los decimales que hacen falta para la suma de un juego de denominaciones. */
export const decimalesDelTotal = (...listas) =>
  Math.max(0, ...listas.flat().map(decimalesDeLaDenominacion));

export const getDenominacionesConfig = (pais) =>
  configuracionDePais(DENOMINACIONES_CONFIG, pais, "denominaciones");
